import * as AccordionPrimitive from "@radix-ui/react-accordion";

export const AccordionRoot = AccordionPrimitive.Root;
